import { render, staticRenderFns } from "./SearchBlock.vue?vue&type=template&id=1146e73c&scoped=true"
import script from "./SearchBlock.vue?vue&type=script&lang=ts"
export * from "./SearchBlock.vue?vue&type=script&lang=ts"
import style0 from "./SearchBlock.vue?vue&type=style&index=0&id=1146e73c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1146e73c",
  null
  
)

export default component.exports